import api from '../config/api/amazon'

export const amazonServices = {
    sendSms: (data = {}) =>
        api.post('/api/v1/sms/enviar', data)
}